/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { injectIntl, FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import classnames from "classnames";
import Tooltip from "@material-ui/core/Tooltip";
import { ROUTES } from "../../../commons/routes/routes";
import { MenuLogo } from "../../../presentation/components/logo";

class AppMenu extends PureComponent {
  render() {
    const { open, handleLogout, location, isUserAdmin, isAuthenticated, isLoginAuth, isCadIncompleto, intl } =
      this.props;
    const { pathname } = location;

    return (
      <nav
        className={classnames("sds-sidemenu", { "sds-sidemenu--open": open })}
        open={open}
        aria-label="Menu"
      >
        <ul className="sds-sidemenu__list">
          {/* Início */}
          <Tooltip
            title={
              !open ? <FormattedMessage id="LABELS.COMMONS.MENU.HOME" /> : ""
            }
          >
            <li
              className={classnames("sds-sidemenu__item", {
                "sds-sidemenu__item--active": pathname === ROUTES.HOME.path,
              })}
            >
              <Link
                to={ROUTES.HOME.path}
                onClick={isCadIncompleto ? (e) => e.preventDefault() : this.props.closeMenuOnMobile}
                aria-label={`${intl.formatMessage({
                  id: "LABELS.COMMONS.MENU.HOME",
                })}`}
              >
                <i className="material-icons" aria-hidden="true">
                  home
                </i>
                <FormattedMessage id="LABELS.COMMONS.MENU.HOME" />
              </Link>
            </li>
          </Tooltip>

          {/* Consulta Processo */}
          <Fragment>
            <Tooltip
              title={
                !open ? (
                  <FormattedMessage id="LABELS.COMMONS.MENU.CONSULTA_PROCESSOS" />
                ) : (
                  ""
                )
              }
            >
              <li
                className={classnames("sds-sidemenu__item", {
                  "sds-sidemenu__item--active":
                    pathname === ROUTES.CONSULTA_PROCESSO.path,
                })}
              >
                <Link
                  to={ROUTES.CONSULTA_PROCESSO.path}
                  onClick={isCadIncompleto ? (e) => e.preventDefault() : this.props.closeMenuOnMobile}
                  aria-label={`${intl.formatMessage({
                    id: "LABELS.COMMONS.MENU.CONSULTA_PROCESSOS",
                  })}`}
                >
                  <i className="material-icons" aria-hidden="true">
                    ballot
                  </i>
                  <FormattedMessage id="LABELS.COMMONS.MENU.CONSULTA_PROCESSOS" />
                </Link>
              </li>
            </Tooltip>
          </Fragment>

          {/* Conferencia de Documentos */}
          <Fragment>
            <Tooltip
              title={
                !open ? (
                  <FormattedMessage id="LABELS.COMMONS.MENU.CONFERENCIA_DOCUMENTOS" />
                ) : (
                  ""
                )
              }
            >
              <li
                className={classnames("sds-sidemenu__item", {
                  "sds-sidemenu__item--active":
                    pathname === ROUTES.CONFERENCIA_DOCUMENTO.path,
                })}
              >
                <Link
                  to={ROUTES.CONFERENCIA_DOCUMENTO.path}
                  onClick={isCadIncompleto ? (e) => e.preventDefault() : this.props.closeMenuOnMobile}
                  aria-label={`${intl.formatMessage({
                    id: "LABELS.COMMONS.MENU.CONFERENCIA_DOCUMENTOS",
                  })}`}
                >
                  <i className="material-icons" aria-hidden="true">
                    assignment
                  </i>
                  <FormattedMessage id="LABELS.COMMONS.MENU.CONFERENCIA_DOCUMENTOS" />
                </Link>
              </li>
            </Tooltip>
          </Fragment>

          {/* Serviços */}
          <Tooltip
            title={
              !open ? (
                <FormattedMessage id="LABELS.COMMONS.MENU.SOLICITACAO_SERVICO" />
              ) : (
                ""
              )
            }
          >
            <li
              className={classnames("sds-sidemenu__item", {
                "sds-sidemenu__item--active": pathname === "/servicos",
              })}
            >
              <Link
                to={"/servicos"}
                onClick={isCadIncompleto ? (e) => e.preventDefault() : this.props.closeMenuOnMobile}
                aria-label={`${intl.formatMessage({
                  id: "LABELS.COMMONS.MENU.SOLICITACAO_SERVICO",
                })}`}
              >
                <i className="material-icons" aria-hidden="true">
                  create_new_folder
                </i>
                <FormattedMessage id="LABELS.COMMONS.MENU.SOLICITACAO_SERVICO" />
              </Link>
            </li>
          </Tooltip>

          {/* Meus Processos */}
          {isAuthenticated && (
            <Tooltip
              title={
                !open ? (
                  <FormattedMessage id="LABELS.COMMONS.MENU.MINHAS_SOLICITACOES" />
                ) : (
                  ""
                )
              }
            >
              <li
                className={classnames("sds-sidemenu__item", {
                  "sds-sidemenu__item--active":
                    pathname === ROUTES.MINHAS_SOLICITACOES.path,
                })}
              >
                <Link
                  to={ROUTES.MINHAS_SOLICITACOES.path}
                  onClick={isCadIncompleto ? (e) => e.preventDefault() : this.props.closeMenuOnMobile}
                  aria-label={`${intl.formatMessage({
                    id: "LABELS.COMMONS.MENU.MINHAS_SOLICITACOES",
                  })}`}
                >
                  <i className="material-icons" aria-hidden="true">
                    library_books
                  </i>
                  <FormattedMessage id="LABELS.COMMONS.MENU.MINHAS_SOLICITACOES" />
                </Link>
              </li>
            </Tooltip>
          )}

          {/* Minhas Pendências */}
          {isAuthenticated && (
            <Tooltip
              title={
                !open ? (
                  <FormattedMessage id="LABELS.COMMONS.MENU.MINHAS_PENDENCIAS" />
                ) : (
                  ""
                )
              }
            >
              <li
                className={classnames("sds-sidemenu__item", {
                  "sds-sidemenu__item--active":
                    pathname === ROUTES.MINHAS_PENDENCIAS.path,
                })}
              >
                <Link
                  to={ROUTES.MINHAS_PENDENCIAS.path}
                  onClick={isCadIncompleto ? (e) => e.preventDefault() : this.props.closeMenuOnMobile}
                  aria-label={`${intl.formatMessage({
                    id: "LABELS.COMMONS.MENU.MINHAS_PENDENCIAS",
                  })}`}
                >
                  {/* <i className="material-icons">list_alt</i> */}
                  <i
                    className="material-icons fas fa-file-signature"
                    style={{ fontSize: 21.5 }}
                    aria-hidden="true"
                  />
                  <FormattedMessage id="LABELS.COMMONS.MENU.MINHAS_PENDENCIAS" />
                </Link>
              </li>
            </Tooltip>
          )}

          {/* Meus Pagamentos */}
          {isAuthenticated && this.props.intl.messages["LABELS.COMMONS.SIGLA_CLIENTE"] === "ONR" && (
            <Tooltip
              title={
                !open ? (
                  <FormattedMessage id="LABELS.COMMONS.MENU.MEUS_PAGAMENTOS" />
                ) : (
                  ""
                )
              }
            >
              <li
                className={classnames("sds-sidemenu__item", {
                  "sds-sidemenu__item--active":
                    pathname === ROUTES.MEUS_PAGAMENTOS.path,
                })}
              >
                <Link
                  to={ROUTES.MEUS_PAGAMENTOS.path}
                  onClick={isCadIncompleto ? (e) => e.preventDefault() : this.props.closeMenuOnMobile}
                  aria-label={`${intl.formatMessage({
                    id: "LABELS.COMMONS.MENU.MEUS_PAGAMENTOS",
                  })}`}
                >
                  {/* <i className="material-icons">list_alt</i> */}
                  <i
                    className="material-icons fas fa-credit-card"
                    style={{ fontSize: 21.5 }}
                    aria-hidden="true"
                  />
                  <FormattedMessage id="LABELS.COMMONS.MENU.MEUS_PAGAMENTOS" />
                </Link>
              </li>
            </Tooltip>
          )}

          {/* Processos Liberados */}
          {isAuthenticated && (
            <Fragment>
              <Tooltip
                title={
                  !open ? (
                    <FormattedMessage id="LABELS.COMMONS.MENU.PROCESSOS_LIBERADOS" />
                  ) : (
                    ""
                  )
                }
              >
                <li
                  className={classnames("sds-sidemenu__item", {
                    "sds-sidemenu__item--active":
                      pathname === "/processos-liberados",
                  })}
                >
                  <Link
                    to={"/processos-liberados"}
                    onClick={isCadIncompleto ? (e) => e.preventDefault() : this.props.closeMenuOnMobile}
                    aria-label={`${intl.formatMessage({
                      id: "LABELS.COMMONS.MENU.PROCESSOS_LIBERADOS",
                    })}`}
                  >
                    <i className="material-icons" aria-hidden="true">
                      folder
                    </i>
                    <FormattedMessage id="LABELS.COMMONS.MENU.PROCESSOS_LIBERADOS" />
                  </Link>
                </li>
              </Tooltip>
            </Fragment>
          )}

          {/* Areas Interesses */}
          {/* {this.props.intl.messages["LABELS.COMMONS.MENU.AREAS_INTERESSES"] && (
            <Tooltip
              title={
                !open ? (
                  <FormattedMessage id="LABELS.COMMONS.MENU.AREAS_INTERESSES" />
                ) : (
                  ""
                )
              }
            >
              <li
                className={classnames("sds-sidemenu__item", {
                  "sds-sidemenu__item--active":
                    pathname === ROUTES.AREAS_INTERESSES.path,
                })}
              >
                <Link
                  to={ROUTES.AREAS_INTERESSES.path}
                  onClick={this.props.closeMenuOnMobile}
                  aria-label={`${intl.formatMessage({
                      id: "LABELS.COMMONS.MENU.AREAS_INTERESSES",
                    })}`}
                >
                  <i className="material-icons" aria-hidden="true">view_list</i>
                  <FormattedMessage id="LABELS.COMMONS.MENU.AREAS_INTERESSES" />
                </Link>
              </li>
            </Tooltip>
          )} */}

          {/* DIVISÃO */}
          <template className="app-tool-bar-divider-container" aria-hidden="true">
            <hr className="sds-line-divider"/>
          </template>

          {/* Antigo Menu de Alterar Dados */}
          {/* {isAuthenticated && (
            <Fragment>
              <Tooltip
                title={
                  !open ? (
                    <FormattedMessage id="LABELS.COMMONS.MENU.MEUS_DADOS" />
                  ) : (
                    ""
                  )
                }
              >
                <li
                  className={classnames("sds-sidemenu__item", {
                    "sds-sidemenu__item--active":
                      pathname === ROUTES.EDITAR_CONTA.path,
                  })}
                >
                  <Link
                    to={ROUTES.EDITAR_CONTA.path}
                    onClick={this.props.closeMenuOnMobile}
                  >
                    <i className="material-icons" aria-hidden="true">person</i>
                    <FormattedMessage id="LABELS.COMMONS.MENU.MEUS_DADOS" />
                  </Link>
                </li>
              </Tooltip>
            </Fragment>
          )} */}

          {/* Menu Meus Dados */}
          {isAuthenticated && (
            <Fragment>
              <Tooltip
                title={
                  !open ? (
                    <FormattedMessage id="LABELS.COMMONS.MENU.MEUS_DADOS" />
                  ) : (
                    ""
                  )
                }
              >
                <li
                  className={classnames("sds-sidemenu__item", {
                    "sds-sidemenu__item--active":
                      pathname === ROUTES.EDITAR_CONTA_DADOS.path,
                  })}
                >
                  <Link
                    to={ROUTES.EDITAR_CONTA_DADOS.path}
                    onClick={this.props.closeMenuOnMobile}
                    aria-label={`${intl.formatMessage({
                      id: "LABELS.COMMONS.MENU.MEUS_DADOS",
                    })}`}
                  >
                    <i className="material-icons" aria-hidden="true">
                      manage_accounts
                    </i>
                    <FormattedMessage id="LABELS.COMMONS.MENU.MEUS_DADOS" />
                  </Link>
                </li>
              </Tooltip>
            </Fragment>
          )}

          {/* Troca de Senha */}
          {isAuthenticated && isLoginAuth && (
            <Fragment>
              <Tooltip
                title={
                  !open ? (
                    <FormattedMessage id="LABELS.COMMONS.MENU.TROCAR_SENHA" />
                  ) : (
                    ""
                  )
                }
              >
                <li
                  className={classnames("sds-sidemenu__item", {
                    "sds-sidemenu__item--active":
                      pathname === ROUTES.TROCAR_SENHA.path,
                  })}
                >
                  <Link
                    to={ROUTES.TROCAR_SENHA.path}
                    onClick={this.props.closeMenuOnMobile}
                    aria-label={`${intl.formatMessage({
                      id: "LABELS.COMMONS.MENU.TROCAR_SENHA",
                    })}`}
                  >
                    <i className="material-icons" aria-hidden="true">
                      password
                    </i>
                    <FormattedMessage id="LABELS.COMMONS.MENU.TROCAR_SENHA" />
                  </Link>
                </li>
              </Tooltip>
            </Fragment>
          )}

          {/* Configurações */}
          {isUserAdmin && (
            <Fragment>
              <template className="app-tool-bar-divider-container" aria-hidden="true">
                <hr className="sds-line-divider" />
              </template>
              <Tooltip
                title={
                  !open ? (
                    <FormattedMessage id="LABELS.COMMONS.MENU.CONFIGURACOES" />
                  ) : (
                    ""
                  )
                }
              >
                <li
                  className={classnames("sds-sidemenu__item", {
                    "sds-sidemenu__item--active":
                      pathname === ROUTES.CONFIGURACOES.path,
                  })}
                >
                  <Link
                    to={ROUTES.CONFIGURACOES.path}
                    onClick={this.props.closeMenuOnMobile}
                    aria-label={`${intl.formatMessage({
                      id: "LABELS.COMMONS.MENU.CONFIGURACOES",
                    })}`}
                  >
                    <i className="material-icons" aria-hidden="true">
                      settings
                    </i>
                    <FormattedMessage id="LABELS.COMMONS.MENU.CONFIGURACOES" />
                  </Link>
                </li>
              </Tooltip>
              <template className="app-tool-bar-divider-container" aria-hidden="true">
                <hr className="sds-line-divider" />
              </template>
            </Fragment>
          )}

          {/* Sair */}
          {isAuthenticated && (
            <Fragment>
              <Tooltip
                title={
                  !open ? (
                    <FormattedMessage id="LABELS.COMMONS.MENU.SAIR" />
                  ) : (
                    ""
                  )
                }
              >
                <li className="sds-sidemenu__item">
                  <Link
                    to="#"
                    onClick={handleLogout}
                    aria-label={`${intl.formatMessage({
                      id: "LABELS.COMMONS.MENU.SAIR",
                    })}`}
                  >
                    <i className="material-icons rotate-180" aria-hidden="true">
                      exit_to_app
                    </i>
                    <FormattedMessage id="LABELS.COMMONS.MENU.SAIR" />
                  </Link>
                </li>
              </Tooltip>
            </Fragment>
          )}
          {/* Entrar */}
          {!isAuthenticated && (
            <Fragment>
              <Tooltip
                title={
                  !open ? (
                    <FormattedMessage id="LABELS.COMMONS.MENU.ENTRAR" />
                  ) : (
                    ""
                  )
                }
              >
                <li
                  className={classnames("sds-sidemenu__item", {
                    "sds-sidemenu__item--active":
                      pathname === ROUTES.LOGIN.path,
                  })}
                >
                  <Link
                    to={ROUTES.LOGIN.path}
                    onClick={this.props.closeMenuOnMobile}
                    aria-label={`${intl.formatMessage({
                      id: "LABELS.COMMONS.MENU.ENTRAR",
                    })}`}
                  >
                    <i className="material-icons" aria-hidden="true">
                      exit_to_app
                    </i>
                    <FormattedMessage id="LABELS.COMMONS.MENU.ENTRAR" />
                  </Link>
                </li>
              </Tooltip>
            </Fragment>
          )}

          {/* Divisor. Precisa exibir se houver algum dos itens abaixo*/}
          {(this.props.intl.messages["LABELS.COMMONS.MENU.AJUDA.LINK"] ||
            this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.PRIMEIRO.LINK"] ||
            this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.SEGUNDO.LINK"] ||
            this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.TERCEIRO.LINK"]) && (
              <template className="app-tool-bar-divider-container" aria-hidden="true">
                <hr className="sds-line-divider" />
              </template>
            )}

          {/* Ajuda */}
          {this.props.intl.messages["LABELS.COMMONS.MENU.AJUDA.LINK"] && (
            <Fragment>
              <Tooltip
                title={
                  !open ? (
                    <FormattedMessage id="LABELS.COMMONS.MENU.AJUDA" />
                  ) : (
                    ""
                  )
                }
              >
                <li className={classnames("sds-sidemenu__item")}>
                  <a
                    href={
                      this.props.intl.messages["LABELS.COMMONS.MENU.AJUDA.LINK"]
                    }
                    rel="noopener noreferrer"
                    target="_blank"
                    onClick={this.props.closeMenuOnMobile}
                    aria-label={`${intl.formatMessage({
                      id: "LABELS.COMMONS.MENU.AJUDA",
                    })}`}
                  >
                    <i className="material-icons" aria-hidden="true">
                      help
                    </i>
                    <FormattedMessage id="LABELS.COMMONS.MENU.AJUDA" />
                  </a>
                </li>
              </Tooltip>
            </Fragment>
          )}

          {this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.PRIMEIRO.ICONE"] &&
            this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.PRIMEIRO.LINK"] &&
            this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.PRIMEIRO.TITULO"] && (
              <Tooltip title={!open ? <FormattedMessage id="LABELS.COMMONS.MENU.ITEM_EXTRA.PRIMEIRO.TITULO" /> : ""}>
                <li className={classnames("sds-sidemenu__item")}>
                  <a
                    href={this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.PRIMEIRO.LINK"]}
                    rel="noopener noreferrer"
                    target="_blank"
                    onClick={this.props.closeMenuOnMobile}
                    aria-label={`${intl.formatMessage({ id: "LABELS.COMMONS.MENU.ITEM_EXTRA.PRIMEIRO.TITULO" })}`}>
                    <i className="material-icons" aria-hidden="true">
                      {`${intl.formatMessage({ id: "LABELS.COMMONS.MENU.ITEM_EXTRA.PRIMEIRO.ICONE" })}`}
                    </i>
                    <FormattedMessage id="LABELS.COMMONS.MENU.ITEM_EXTRA.PRIMEIRO.TITULO" />
                  </a>
                </li>
              </Tooltip>
            )}

          {this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.SEGUNDO.ICONE"] &&
            this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.SEGUNDO.LINK"] &&
            this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.SEGUNDO.TITULO"] && (
              <Tooltip title={!open ? <FormattedMessage id="LABELS.COMMONS.MENU.ITEM_EXTRA.SEGUNDO.TITULO" /> : ""}>
                <li className={classnames("sds-sidemenu__item")}>
                  <a
                    href={this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.SEGUNDO.LINK"]}
                    rel="noopener noreferrer"
                    target="_blank"
                    onClick={this.props.closeMenuOnMobile}
                    aria-label={`${intl.formatMessage({ id: "LABELS.COMMONS.MENU.ITEM_EXTRA.SEGUNDO.TITULO" })}`}>
                    <i className="material-icons" aria-hidden="true">
                      {`${intl.formatMessage({ id: "LABELS.COMMONS.MENU.ITEM_EXTRA.SEGUNDO.ICONE" })}`}
                    </i>
                    <FormattedMessage id="LABELS.COMMONS.MENU.ITEM_EXTRA.SEGUNDO.TITULO" />
                  </a>
                </li>
              </Tooltip>
            )}

          {this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.TERCEIRO.ICONE"] &&
            this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.TERCEIRO.LINK"] &&
            this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.TERCEIRO.TITULO"] && (
              <Tooltip title={!open ? <FormattedMessage id="LABELS.COMMONS.MENU.ITEM_EXTRA.TERCEIRO.TITULO" /> : ""}>
                <li className={classnames("sds-sidemenu__item")}>
                  <a
                    href={this.props.intl.messages["LABELS.COMMONS.MENU.ITEM_EXTRA.TERCEIRO.LINK"]}
                    rel="noopener noreferrer"
                    target="_blank"
                    onClick={this.props.closeMenuOnMobile}
                    aria-label={`${intl.formatMessage({ id: "LABELS.COMMONS.MENU.ITEM_EXTRA.TERCEIRO.TITULO" })}`}>
                    <i className="material-icons" aria-hidden="true">
                      {`${intl.formatMessage({ id: "LABELS.COMMONS.MENU.ITEM_EXTRA.TERCEIRO.ICONE" })}`}
                    </i>
                    <FormattedMessage id="LABELS.COMMONS.MENU.ITEM_EXTRA.TERCEIRO.TITULO" />
                  </a>
                </li>
              </Tooltip>
            )}

          {/* MENU OUVIDORIA */}
          {this.props.intl.messages["LABELS.COMMONS.MENU.OUVIDORIA.LINK"] && (
            <Fragment>
              <template className="app-tool-bar-divider-container" aria-hidden="true">
                <hr className="sds-line-divider" />
              </template>
              <Tooltip
                title={
                  !open ? (
                    <FormattedMessage id="LABELS.COMMONS.MENU.OUVIDORIA" />
                  ) : (
                    ""
                  )
                }
              >
                <li className={classnames("sds-sidemenu__item")}>
                  <a
                    href={
                      this.props.intl.messages[
                        "LABELS.COMMONS.MENU.OUVIDORIA.LINK"
                      ]
                    }
                    rel="noopener noreferrer"
                    target="_blank"
                    onClick={this.props.closeMenuOnMobile}
                    aria-label={`${intl.formatMessage({
                      id: "LABELS.COMMONS.MENU.OUVIDORIA",
                    })}`}
                  >
                    <i className="material-icons" aria-hidden="true">
                      info
                    </i>
                    <FormattedMessage id="LABELS.COMMONS.MENU.OUVIDORIA" />
                  </a>
                </li>
              </Tooltip>
            </Fragment>
          )}

        </ul>

        {/* Logo */}
        <Fragment>
          <div className="sds-sidemenu__list app-menu__logo">
            <div className="sds-sidemenu__item sds-sidemenu__item_logo">
              <a
                href={this.props.intl.messages["LABELS.COMMONS.SIGLA_CLIENTE"] === "ONR"
                      ? "https://onserp.org.br/"
                      : "https://www.solarbpm.softplan.com.br/suporte/#portais"}
                rel="noopener noreferrer"
                target="_blank"
                onClick={this.props.closeMenuOnMobile}
                aria-label={this.props.intl.messages["LABELS.COMMONS.SIGLA_CLIENTE"] === "ONR"
                            ? "Acessar Site OnSerp"
                            : "Acessar Site Solar BPM"}
              >
                {!open ? (
                  <MenuLogo
                    open={open}
                    cliente={this.props.intl.messages["LABELS.COMMONS.SIGLA_CLIENTE"]}
                  />
                ) : (
                  <div className="sds-sidemenu-solar-img" aria-hidden="true">
                    <img
                      src={this.props.intl.messages["LABELS.COMMONS.SIGLA_CLIENTE"] === "ONR"
                          ? `${process.env.PUBLIC_URL}/assets/imgs/logo-onserp-onr.png`
                          : `${process.env.PUBLIC_URL}/assets/imgs/logo-solar-bpm.png`}
                      alt={this.props.intl.messages["LABELS.COMMONS.SIGLA_CLIENTE"] === "ONR"
                          ? "OnSerp"
                          : "Solar BPM"}
                      aria-hidden="true"
                      style={{width: "15em"}}
                    />
                  </div>
                )}
              </a>
            </div>
          </div>
        </Fragment>
        <div
          className="sds-sidemenu__overlay"
          onClick={this.props.menuToggle}
        />
      </nav>
    );
  }
}

AppMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  handleLogout: PropTypes.func.isRequired,
  menuToggle: PropTypes.func.isRequired,
  closeMenuOnMobile: PropTypes.func.isRequired,
  isUserAdmin: PropTypes.bool.isRequired,
  isLoginAuth: PropTypes.bool.isRequired,
  isCadIncompleto: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

export default compose(injectIntl, withRouter)(AppMenu);
